import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "input-file__wrapper" }
const _hoisted_2 = { class: "input-file__first" }
const _hoisted_3 = {
  key: 0,
  class: "input-file__title"
}
const _hoisted_4 = {
  key: 0,
  class: "input-file__number"
}
const _hoisted_5 = {
  key: 1,
  class: "input-file__title-text"
}
const _hoisted_6 = {
  key: 1,
  class: "input-file__desc"
}
const _hoisted_7 = { class: "input-file__input" }
const _hoisted_8 = {
  key: 0,
  class: "input-file__filename"
}
const _hoisted_9 = ["for"]
const _hoisted_10 = ["id", "accept"]
const _hoisted_11 = {
  key: 1,
  class: "input-file__error"
}
const _hoisted_12 = {
  key: 2,
  class: "input-file__error",
  "data-error": "true"
}
const _hoisted_13 = {
  key: 0,
  class: "input-file__middle"
}
const _hoisted_14 = { class: "input-file__last" }
const _hoisted_15 = ["src"]

import { computed, ref } from 'vue'
import { useVModel } from '@vueuse/core'
import { idGenerator, getExtension } from '@/common/helpers'

// Components
import Button from '@/components/ui/Button'

// i18n
import { useI18n } from 'vue-i18n'
import type { Props } from './index'
import DrawSvg from '@/common/DrawSvg/DrawSvg.vue'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'InputFile',
  props: {
    modelValue: {},
    accept: { default: '.gif, .jpeg, .jpg, .png' },
    maxFileSize: { default: 26214400 },
    disabled: { type: Boolean },
    error: {},
    number: {},
    title: {},
    desc: {},
    demo: {},
    required: { type: Boolean },
    placeholder: {},
    value: {}
  },
  emits: ["update:modelValue", "showDemo", "update:error"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()

// Types
const props = __props

// Emits
const emit = __emit

// Data
let model = useVModel(props, 'modelValue', emit)
const proxiedError = useVModel(props, 'error', emit)
const draggable = ref<boolean>(false)
const id = idGenerator()
const input = ref()
const error = ref<Array<string>>([])
const fileToUpload = ref<any | null>(null)

// Computed
const image = computed<string | null>(() => {
  const file = (model.value) ? URL.createObjectURL(model.value) : null
  return file ?? props.value
})

// Methods
function clearError(): void {
  proxiedError.value = null
}

function setValue(event: Event): void {
  const target = event.target as HTMLInputElement
  let file = target.files?.[0] ?? null
  clearError();
  if (!file?.name) {
    return
  }

  const ext = getExtension(file!.name).toLowerCase() ?? null
  const isAllow = props.accept.includes(ext)
  error.value = []

  if (!isAllow) {
    error.value.push(t('inputFile.notAccept'))
  }

  if (file.size && file.size > props.maxFileSize) {
    error.value.push(t('inputFile.sizeLimit'))
  }


  if (!error.value.length) {
    fileToUpload.value = file?.name
    model.value = file
  } else {
    reset()
  }
}

function reset(): void {
  input.value.value = ''
  fileToUpload.value = null
  model.value = null
}

function tryToShowDemo(imageUrl: string): void {
  emit('showDemo', imageUrl)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "input-file",
    onClick: clearError
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.number || _ctx.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.number)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.number), 1))
                : _createCommentVNode("", true),
              (_ctx.title)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.title), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.desc)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.desc), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (fileToUpload.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(fileToUpload.value), 1),
                _createVNode(_unref(Button), {
                  theme: "icon",
                  onClick: reset
                }, {
                  default: _withCtx(() => [
                    _createVNode(DrawSvg, {
                      name: "close",
                      width: "20",
                      height: "20"
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("label", {
            class: _normalizeClass(["input-file__label", {'input-file__label-draggable': draggable.value}]),
            for: `input-${_unref(id)}`,
            onDragstart: _cache[0] || (_cache[0] = ($event: any) => (draggable.value = true)),
            onDragover: _cache[1] || (_cache[1] = ($event: any) => (draggable.value = true)),
            onDragleave: _cache[2] || (_cache[2] = ($event: any) => (draggable.value = false)),
            onDrop: _cache[3] || (_cache[3] = ($event: any) => (draggable.value = false))
          }, [
            _createVNode(DrawSvg, {
              name: "upload-photo",
              width: "20",
              height: "20"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.placeholder) + " ", 1),
            _createElementVNode("input", {
              ref_key: "input",
              ref: input,
              id: `input-${_unref(id)}`,
              type: "file",
              onChange: setValue,
              accept: _ctx.accept
            }, null, 40, _hoisted_10)
          ], 42, _hoisted_9),
          (error.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(error.value, (error) => {
                  return (_openBlock(), _createElementBlock("div", null, _toDisplayString(error), 1))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(proxiedError))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(proxiedError)), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.demo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_unref(Button), {
              theme: "demo",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (tryToShowDemo(_ctx.demo)))
            }, {
              append: _withCtx(() => [
                _createVNode(DrawSvg, {
                  name: "eye",
                  width: "20",
                  height: "20"
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('inputFile.demo')) + " ", 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        (image.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: image.value
            }, null, 8, _hoisted_15))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})